import { Component , ViewChild } from '@angular/core';
import { NavController, NavParams, Slides, LoadingController } from 'ionic-angular';
import { ApiService } from '../../app/services/api.service';
import { Broadcaster } from '../../app/broadcaster';
import { Storage } from '@ionic/storage';
import { OkageStorageProvider } from '../../providers/okage-storage/okage-storage';

@Component({
  selector: 'page-ranking',
  templateUrl: 'ranking.html',
  providers: [ApiService]
})

export class RankingPage {

	@ViewChild('pageSlider') pageSlider: Slides;
	tabs: any = '0';

  items: Array<Array<{id: number, title: string, desc: string, thumb: string, price: number, like: number; aIndex: number, iIndex: number}>>;
  iFoods: Array<Array<number>>;
  iTotal: number;
  loading: any;

  /**
   *
   * @param navCtrl
   * @param navParams
   * @param _productService
   */
	constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private _apiService: ApiService,
              private storage: Storage,
              private broadcaster: Broadcaster,
              private _okageStorage: OkageStorageProvider,
              private loadingCtrl: LoadingController) {
    this.loading = this.loadingCtrl.create();
    this.iFoods = [];
    this.items = [];

    this.loading.present();
    this._apiService.getRankingList(3).subscribe(
      (result) => {
        this.loading.dismiss();
        if (result.status == 1000 && result.content.length) {
          //console.log("result this.foods: " + JSON.stringify(this.foods));
          for (var i = 0; i < result.content.length; i++) {
            if (!this.items[i]) {
              this.items[i] = [];
            }
            for (var j = 0; j < result.content[i].length; j++) {
              this.items[i][j] = {
                id: result.content[i][j].id,
                title: result.content[i][j].title,
                desc: result.content[i][j].desc,
                thumb: result.content[i][j].thumb,
                price: result.content[i][j].price,
                like: result.content[i][j].like,
                aIndex: -1,
                iIndex: -1
              };
            }
          }
          
          this.storage.get('foods.menu').then((m) => {
            for (var i = 0; i < m.length; i++) {
              for (var j = 0; j < m[i].length; j++) {
                for (var k = 0; k < this.items.length; k++) {
                  for (var t = 0; t < this.items[k].length; t++) {
                    if (this.items[k][t].id == m[i][j].id) {
                      this.items[k][t].aIndex = i;
                      this.items[k][t].iIndex = j;
                      break;
                    }
                  }
                }
              }
            }
            this.foodCounterChanged();
          });
        }

      }, error => {
        console.log(error);
        this.loading.dismiss();
      });

/*
    this.storage.get('foods.menu_bk').then((f) => {
      if (f) {
        this.foods = f;
        console.log(f);
        for (var i = 0; i < 3; i++) {
          if (!this.items[i]) {
            this.items[i] = [];
          }
          for (var j = 0; j < 10; j++) {
            this.items[i][j] = {
              id: this.foods[i][j].id,
              title: this.foods[i][j].title,
              desc: this.foods[i][j].desc,
              thumb: this.foods[i][j].thumb,
              price: this.foods[i][j].price,
              like: this.foods[i][j].like,
            };
          }
        }
        this.foodCounterChanged();
      }
    });
    */
    
    this.broadcaster.on<number>('foodCounterChanged')
      .subscribe(from => {
        if (from != 4) {
          this.foodCounterChanged();
        }
      });
  }

  foodCounterChanged() {
    this.iFoods = [];
    this.iTotal = 0;
    this.storage.get('foods.selected').then((v) => {
      if (v) {
        this.iFoods = v;
      }
      this.countTotal();
    });
  }

  chooseFood(aIndex, iIndex) {
    if (!this.iFoods[aIndex]) {
      this.iFoods[aIndex] = [];
    }
    if (!this.iFoods[aIndex][iIndex]) {
      this.iFoods[aIndex][iIndex] = 0;
    }
    this.iFoods[aIndex][iIndex]++;
    this.storage.set('foods.selected', this.iFoods).then((a) => {
      this.countTotal();
      this.broadcaster.broadcast('foodCounterChanged', 4);
    });
  }

  removeFood(aIndex, iIndex) {
    if (!this.iFoods[aIndex][iIndex]) {
      return;
    }
    this.iFoods[aIndex][iIndex]--;
    this.storage.set('foods.selected', this.iFoods).then((a) => {
      this.countTotal();
      this.broadcaster.broadcast('foodCounterChanged', 4);
    });
  }

  private countTotal() {
    var total = 0;
    for(var i = 0; i < 3; i++) {
      if (this.iFoods[i]) {
        for(var j = 0; j < this.iFoods[i].length; j++) {
          if (this.iFoods[i][j]) {
            total += this.iFoods[i][j];
          }
        }
      }
    }
    this.iTotal = total;
    this.storage.set('iTotal', this.iTotal);
  }

	ionViewDidLoad() {
	}
	selectTab(index) {
		this.pageSlider.slideTo(index);
	}

	changeWillSlide($event) {
	 	this.tabs = $event._snapIndex.toString();
	}

  sendOrder() {
    this.navCtrl.parent.select(6);
  }
}



// WEBPACK FOOTER //
// ./src/pages/ranking/ranking.ts